import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { current, logout } from "../Redux/Actions/AuthActions";
import { useNavigate } from "react-router-dom";
import { Container, Card, Row, Col, Button, Form, Badge, Tab, Nav, Alert, Spinner } from "react-bootstrap";
import axios from "axios";
import "./NProfil.css";

const NProfil = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [editPhone, setEditPhone] = useState("");
    const [editName, setEditName] = useState("");
    const [savingProfile, setSavingProfile] = useState(false);
    const [profileMsg, setProfileMsg] = useState(null);
    const [appointments, setAppointments] = useState([]);
    const [loadingAppts, setLoadingAppts] = useState(false);

    useEffect(() => {
        dispatch(current());
    }, [dispatch]);

    const user = useSelector((state) => state.AuthReducer.user);

    useEffect(() => {
        if (user) {
            setEditPhone(user.phone ? user.phone.toString() : "");
            setEditName(user.name || "");
            fetchAppointments();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?._id]);

    const fetchAppointments = async () => {
        const token = localStorage.getItem("token");
        if (!token) return;
        setLoadingAppts(true);
        try {
            const res = await axios.get("/api/appointments", { headers: { Authorization: token } });
            setAppointments(res.data || []);
        } catch (err) {
            console.error("Error loading appointments:", err);
        } finally {
            setLoadingAppts(false);
        }
    };

    const handleSaveProfile = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("token");
        setSavingProfile(true);
        setProfileMsg(null);
        try {
            const res = await axios.put(`/api/auth/UpdateUser/${user._id}`, { name: editName, phone: editPhone }, { headers: { Authorization: token } });
            const updatedUser = { ...user, ...(res.data.user || {}) };
            localStorage.setItem("user", JSON.stringify(updatedUser));
            if (res.data.token) localStorage.setItem("token", res.data.token);
            dispatch(current());
            setProfileMsg({ type: "success", text: "Profil mis a jour avec succes !" });
        } catch (err) {
            setProfileMsg({ type: "danger", text: "Erreur lors de la mise a jour." });
        } finally {
            setSavingProfile(false);
        }
    };

    const handleLogout = () => {
        dispatch(logout());
        navigate("/Login");
    };

    const getStatusBadge = (status) => {
        const map = { confirmed: { bg: "success", label: "Confirme" }, pending: { bg: "warning", label: "En attente" }, cancelled: { bg: "danger", label: "Annule" }, completed: { bg: "info", label: "Termine" } };
        const s = map[status] || { bg: "secondary", label: status };
        return <Badge bg={s.bg} className="rounded-pill px-3 py-1">{s.label}</Badge>;
    };

    if (!user) {
        return (
            <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                <div className="text-center"><Spinner animation="border" variant="primary" className="mb-3" /><p className="text-muted">Chargement du profil...</p></div>
            </Container>
        );
    }

    const initials = user.name ? user.name.split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2) : "U";

    return (
        <div className="nprofil-bg">
            <Container className="py-5" style={{ maxWidth: "960px" }}>
                <Card className="nprofil-header-card shadow-lg border-0 mb-4">
                    <Card.Body className="p-0">
                        <div className="nprofil-banner"></div>
                        <div className="px-4 pb-4 pt-2">
                            <div className="d-flex justify-content-between align-items-end flex-wrap gap-3">
                                <div className="d-flex align-items-center gap-4">
                                    <div className="nprofil-avatar shadow">
                                        <span className="nprofil-avatar-initials">{initials}</span>
                                    </div>
                                    <div>
                                        <h3 className="fw-bold mb-0 mt-2">{user.name}</h3>
                                        <p className="text-muted mb-0">{user.email}</p>
                                        {user.phone && <p className="text-muted small mb-0">Tel: {user.phone}</p>}
                                        <Badge bg="primary" className="rounded-pill mt-1 px-3 py-1" style={{ fontSize: "11px", letterSpacing: "1px" }}>CLIENT</Badge>
                                    </div>
                                </div>
                                <Button variant="outline-danger" className="rounded-pill px-4 fw-semibold" onClick={handleLogout}>
                                    Se deconnecter
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Tab.Container defaultActiveKey="profile">
                    <Nav variant="pills" className="nprofil-pills mb-4">
                        <Nav.Item><Nav.Link eventKey="profile">Mon Profil</Nav.Link></Nav.Item>
                        <Nav.Item><Nav.Link eventKey="appointments">Mes Reservations ({appointments.length})</Nav.Link></Nav.Item>
                    </Nav>

                    <Tab.Content>
                        <Tab.Pane eventKey="profile">
                            <Card className="border-0 shadow-sm rounded-4 p-4">
                                <h5 className="fw-bold mb-4 text-secondary">Modifier mes informations</h5>
                                {profileMsg && <Alert variant={profileMsg.type} className="rounded-3" onClose={() => setProfileMsg(null)} dismissible>{profileMsg.text}</Alert>}
                                <Form onSubmit={handleSaveProfile}>
                                    <Row className="g-3">
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label className="fw-semibold text-muted small">Nom complet</Form.Label>
                                                <Form.Control type="text" value={editName} onChange={e => setEditName(e.target.value)} className="rounded-3" required />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label className="fw-semibold text-muted small">Email</Form.Label>
                                                <Form.Control type="email" value={user.email} disabled className="rounded-3 bg-light" />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label className="fw-semibold text-muted small">Telephone</Form.Label>
                                                <Form.Control type="tel" value={editPhone} onChange={e => setEditPhone(e.target.value)} placeholder="Ex: 21234567" className="rounded-3" />
                                                <Form.Text className="text-muted">Ce numero sera automatiquement renseigne lors de vos reservations.</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        {user.localisation && (
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold text-muted small">Localisation</Form.Label>
                                                    <Form.Control type="text" value={user.localisation?.name || user.localisation} disabled className="rounded-3 bg-light" />
                                                </Form.Group>
                                            </Col>
                                        )}
                                    </Row>
                                    <div className="d-flex justify-content-end mt-4">
                                        <Button type="submit" variant="primary" className="rounded-pill px-5 fw-semibold" disabled={savingProfile}>
                                            {savingProfile ? <Spinner animation="border" size="sm" className="me-2" /> : null}
                                            Enregistrer les modifications
                                        </Button>
                                    </div>
                                </Form>
                            </Card>
                        </Tab.Pane>

                        <Tab.Pane eventKey="appointments">
                            <Card className="border-0 shadow-sm rounded-4 p-4">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className="fw-bold text-secondary mb-0">Historique de mes reservations</h5>
                                    <Button variant="outline-primary" size="sm" className="rounded-pill" onClick={fetchAppointments}>Actualiser</Button>
                                </div>
                                {loadingAppts ? (
                                    <div className="text-center py-4"><Spinner animation="border" variant="primary" /></div>
                                ) : appointments.length === 0 ? (
                                    <div className="text-center py-5 text-muted">
                                        <div style={{ fontSize: "48px" }} className="mb-3">Aucune reservation</div>
                                        <Button variant="primary" className="rounded-pill px-4 mt-2" onClick={() => navigate("/")}>Decouvrir les prestataires</Button>
                                    </div>
                                ) : (
                                    <div className="d-flex flex-column gap-3">
                                        {appointments.map(appt => (
                                            <div key={appt._id} className="nprofil-appt-card p-3 rounded-3 border">
                                                <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                                                    <div>
                                                        <div className="fw-bold text-dark mb-1">{appt.provider?.businessName || appt.provider?.name || "Etablissement"}</div>
                                                        <div className="text-muted small mb-1">{appt.service?.name || (appt.services && appt.services.map(s => s.name).join(", ")) || "Service"}</div>
                                                        <div className="text-muted small">{appt.date ? new Date(appt.date).toLocaleDateString("fr-FR", { weekday: "long", year: "numeric", month: "long", day: "numeric" }) : ""}{appt.startTime ? " a " + appt.startTime : ""}</div>
                                                        {appt.guestsCount > 1 && <div className="text-muted small">{appt.guestsCount} personne(s)</div>}
                                                        {appt.bookedResource && <div className="text-muted small">🪑 {typeof appt.bookedResource === 'object' ? appt.bookedResource.name : appt.bookedResource}</div>}
                                                    </div>
                                                    <div className="text-end">
                                                        {getStatusBadge(appt.status)}
                                                        {appt.price && <div className="fw-bold text-primary mt-2" style={{ fontSize: "16px" }}>{appt.price} DT</div>}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </Card>
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </Container>
        </div>
    );
};

export default NProfil;
